import Vue from 'vue'
import Vuex from 'vuex'
import {
  getUserData,
  // getAccessData,
  userLogin,
  userLogOut,
  getProfilePic,
  getAccessData,
} from "../../utils/apiFunction";
import { resetRouter } from "../../router";
import store from '../index.js';
import {
  setToken, getToken,
  getRefreshToken,
  clearCookies,
} from "../../utils/tokenCheck";
// import jwt_decode from "jwt-decode";
const qs = require('qs')
// import axios from "axios";
Vue.use(Vuex)

// State
const state = () => ({
  userDetails: {},
  userInfo: {},
  profileImage: '',
  licenseKey: '',
  token: '',
  refreshToken: '',
  loggedin: true,
  selectedId: 'e8550ed7-4561-4a73-b85f-1b4ff446f9a4',
  user: {
    userID: '',
    email: '',
  },
  universityData: {
    isUniversity: false,
    collegeID: null,
  },
  pageTitle: { titleName: 'Dashboard', path: '/dashboard' },
})

// getters
const getters = {
  getPageTitle: (state) => state.pageTitle,
  getToken: (state) => state.token,
  getUserRefreshToken: (state) => state.refreshToken,
  getUserDetails: (state) => state.userDetails,
  getUser: (state) => state.user,
  getProfileImage: (state) => state.profileImage,
  getSelectedId: (state) => state.selectedId,
  getUniversityData: (state) => state.universityData,
}

// actions
const actions = {
  async getUserData({ commit }) {
    try {
      const response = await getUserData()
      let data = await response.data.data.LicenseKey
      commit('saveLicenseKey', data)

      let payload = {
        licensekey: data,
        user: 'USER',
      }
      const res = await getAccessData(payload)
      let userInfo = await res.data.data.Data[0]
      commit('setUserDetails', userInfo)
      let generatedName = 'Guest'
      if (userInfo.username) {
        generatedName = userInfo.username.split(' ')
        if (generatedName.length > 1) {
          generatedName = generatedName[0][0] + generatedName[1][0]
        } else {
          generatedName = generatedName[0][0]
        }
      } else {
        generatedName = store.state.email
      }
      const userImage = await getProfilePic(generatedName)
      if (userImage.status == 200) {
        commit('saveProfileImage', {
          profileImage: userImage.data.data.link,
        })
      }
    } catch (error) {
      throw new Error(`Getting Licencse Failed! status: ${error.status}`)
    }
  },

  // http://sso.simplifycv.com/
  // https://auth.simplifycv.com/
  // Login Api

  Login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      userLogin(userInfo.keycloak, {
        'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
      })
        .then((response) => {
          const data = response.data
          if (data.access_token) {
            setToken(data.access_token)
            commit('SET_TOKEN', data.access_token)
            commit('SET_REFRESH_TOKEN', data.refresh_token)
            localStorage.setItem('vue_token', data.access_token)
            resolve(response)
          } else {
            reject(data)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // http://sso.simplifycv.com/
  // https://auth.simplifycv.com/
  // LogOut Api
  LogOut(state) {
    resetRouter()

    userLogOut(
      qs.stringify({
        client_id: "vue-test-app",
        refresh_token: getRefreshToken(),
      }),
      {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        Authorization: `Bearer ${getToken()}`,
      }
    )
      .then(() => {
        state.commit("SET_TOKEN", "");
        state.commit("SET_REFRESH_TOKEN", "");
        state.commit("saveLicenseKey", "");
        state.commit("setUserInfo", {});
        clearCookies();
        // location.replace("http://localhost:8080/login?from=collegeDashboard");
        location.replace("https://app.hire3x.com/login?from=collegeDashboard");
        // state.commit("closeSurveyWidget", false);
        // alert("User Logged Out");
      })
      .catch((error) => {
        console.error(error);
        state.commit("SET_TOKEN", "");
        state.commit("SET_REFRESH_TOKEN", "");
        state.commit("saveLicenseKey", "");
        state.commit("setUserInfo", {});
        clearCookies();
        // location.replace("http://localhost:8080/login?from=collegeDashboard");
        location.replace("https://app.hire3x.com/login?from=collegeDashboard");
      });
  },
}

// mutations
const mutations = {
  setUniversityData(state, data) {
    state.universityData = data
  },
  setSelectedId(state, id) {
    state.selectedId = id
  },
  saveProfileImage(state, payload) {
    state.profileImage = payload.profileImage
  },
  setUserDetails(state, details) {
    state.userDetails = details
  },
  setUserInfo(state, payload) {
    state.userInfo = payload
  },
  saveUserData(state, payload) {
    state.user.userID = payload.jwttoken
    state.user.email = payload.email
  },

  // TOGGLE MENU SIDE BAR

  // Storing LicenseKey
  saveLicenseKey(state, payload) {
    state.licenseKey = payload
  },
  // ------- User Data --------- whether the user is loggedIn or not
  checkLoginStatus(state, payload) {
    state.loggedin = payload
  },

  // Storing Token
  SET_TOKEN(state, token) {
    state.token = token
  },
  // Storing Refresh Token
  SET_REFRESH_TOKEN(state, refreshToken) {
    state.refreshToken = refreshToken
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
